module.exports = __webpack_public_path__ + "img/box_shadow_bg_1.a7d75dfa.png";